// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__l89rH","sectionWrapper":"contact_sectionWrapper__JLFxz","heading":"contact_heading__4de5b","img":"contact_img__4VFjj","press":"contact_press__PzE6j"};